export class IErRevisionHistory {
  displayOrder: number;
  erRevisionId: number;
  formVersion: string;
  modifiedBy: string;
  modifiedDate: string;
}
